var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"landing-live-section"},[_c('b-container',[_c('h4',{staticClass:"title"},[_vm._v("Today's live sessions")]),_c('div',{staticClass:"live-tab"},[_c('b-container',[_c('banner-slider',{attrs:{"slides":3,"liveCourses":_vm.liveCourses}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }